import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import { useAuth } from '../context/AuthContext';

interface AuthRouteProps {
    children?: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
    const { user, isLoading } = useAuth();

    // Während des Ladens zeigen wir einen Ladeindikator
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    // Wenn der Benutzer nicht angemeldet ist, leiten wir zur Anmeldeseite weiter
    if (!user) {
        return <Navigate to="/signin" replace />;
    }

    // Wenn der Benutzer angemeldet ist, zeigen wir die geschützte Route
    return (
        <div className="min-h-screen bg-white">
            <Navigation />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {children || <Outlet />}
            </div>
        </div>
    );
};

export default AuthRoute;